export enum TooltipType {
  RENTAL_PROTECTION_PLAN_TOOLTIP = 'RENTAL_PROTECTION_PLAN_TOOLTIP',
  ESTIMATED_DELIVERY_FEE_TOOLTIP = 'ESTIMATED_DELIVERY_FEE_TOOLTIP',
  EQUIPMENT_CHARGES_TOOLTIP = 'EQUIPMENT_CHARGES_TOOLTIP',
  CREDIT_APPLICATION_DENIED_TOOLTIP = 'CREDIT_APPLICATION_DENIED_TOOLTIP',
}
